import React, { createContext, useState, useCallback } from "react";

const StoreContext = createContext({
    storeId: null,
    selectedStore: {},
    selectedStoreConfiguration: {
        isSafetyStatusCheckEnabled: false,
        isSalesForceEmailEnabled: false,
        isServiceHistoryEnabled: false,
        isPreviousInspectionViewEnabled: false,
        isEmailPriorityEnabled: false,
        isStatusInspectionEnabled: false
    }
});

export const StoreProvider = ({ children }) => {
    const [unfilteredStores, setUnfilteredStores] = useState([]);
    const [storeId, setStoreId] = useState(null);
    const [selectedStore, setSelectedStore] = useState({});
    const [selectedStoreConfiguration, setSelectedStoreConfiguration] = useState({
        isSalesForceEmailEnabled: false,
        isSafetyStatusCheckEnabled: false,
        isServiceHistoryEnabled: false,
        isPreviousInspectionViewEnabled: false,
        isEmailPriorityEnabled: false,
        isStatusInspectionEnabled: false
    })

    const setSelectedStoreCallback = useCallback((store) => {
        setSelectedStore(store);
        setSelectedStoreConfiguration({
            isSalesForceEmailEnabled: store?.isSalesForceEmailEnabled || false,
            isSafetyStatusCheckEnabled: store?.isSafetyStatusCheckEnabled || false,
            isServiceHistoryEnabled: store?.isServiceHistoryEnabled || false,
            isPreviousInspectionViewEnabled: store?.isPreviousInspectionViewEnabled || false,
            isEmailPriorityEnabled: store?.isEmailPriorityEnabled || false,
            isStatusInspectionEnabled: store?.isStatusInspectionEnabled || false
        });
    })

    const resetStoreState = () => {
        setStoreId(1);
        setSelectedStore({});
      };
    
    const contextValue = {
        storeId,
        setStoreId,
        selectedStore,
        setSelectedStoreCallback,
        selectedStoreConfiguration,
        setUnfilteredStores,
        unfilteredStores,
        resetStoreState
    }

    return (
        <StoreContext.Provider value={contextValue}>
            {children}
        </StoreContext.Provider>
    );
}

export default StoreContext;